import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './community.css';

const DISMISSED_KEY = 'hammer.profilePhotoPromo.dismissed';

function wasDismissed() {
  try {
    return window.localStorage.getItem(DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

function rememberDismissed() {
  try {
    window.localStorage.setItem(DISMISSED_KEY, '1');
  } catch {
    // Storage blocked: the notice only stays hidden for this session.
  }
}

export function ProfilePhotoPromo() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(wasDismissed);

  if (!user || !['user', 'coach'].includes(user.role) || user.avatarPath || dismissed) return null;

  const close = () => {
    rememberDismissed();
    setDismissed(true);
  };

  return (
    <aside className="community-promo" aria-label="Aviso">
      <p className="community-promo__text">Ahora podés subir tu foto de perfil</p>
      <div className="community-promo__actions">
        <Link to={`/comunidad/perfil/${user.id}`} className="gym-button gym-button--primary community-promo__link">Subir foto</Link>
        <button type="button" className="community-promo__close" aria-label="Cerrar aviso" onClick={close}>✕</button>
      </div>
    </aside>
  );
}
